import Tooltip from "ds_legacy/components/Tooltip";
import { GREY_500 } from "ds_legacy/materials/colors";
import { BodyProps } from "ds_legacy/materials/typography";
import { useHasOverflown } from "dsl/hooks";
import { DefaultCellBodyText } from "../styles";

export const DefaultTextCell = ({
  isDisabled,
  message,
  onClick,
  testId,
  ...bodyProps
}: BodyProps & {
  isDisabled?: boolean;
  message: string | undefined;
  onClick?: () => void;
  testId?: string;
}) => {
  const { hasOverflown, ref } = useHasOverflown<HTMLSpanElement>({
    direction: "y",
    value: message,
  });

  return (
    <Tooltip title={hasOverflown ? message : ""}>
      <DefaultCellBodyText
        data-testid={testId}
        {...bodyProps}
        ref={ref}
        color={isDisabled ? GREY_500 : bodyProps.color}
        onClick={onClick}
      >
        {message}
      </DefaultCellBodyText>
    </Tooltip>
  );
};
